import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    CircularProgress,
} from "@mui/material";
import DeliveryImages from "../../../components/delivery/DeliveryImages";
import { saveBoxImage } from "../../../config";
import { Alerts } from "../../../components/alerts/Alerts.tsx";

const UploadImageDialog = ({ openUploadImageDialog, onClose, token, images, preview, boxId, auth }) => {
    const [loading, setLoading] = useState(false);

    const {
        showErrorRequest,
        alertSuccess
    } = Alerts();

    const saveImages = async () => {
        const body = { images };
        try {
            setLoading(true);
            const response = await saveBoxImage(token, body, boxId);

            // Maneja la respuesta
            if (response.ok) {
                const data = await response.json();
                alertSuccess("Éxito", data.message);
                onClose();
            } else {
                if (response.status === 401 || response.status === 403) {
                    showErrorRequest("No tiene autorización o su sesión ha expirado", auth);
                    return;
                }

                try {
                    const errorData = await response.json();
                    showErrorRequest(errorData.detail || errorData.message || "Error desconocido");
                } catch {
                    const errorText = await response.text();
                    showErrorRequest(`Error del servidor: ${errorText.substring(0, 100)}...`);
                }
            }
        } catch (error) {
            console.error("Error completo:", error);
            showErrorRequest(error.message || "Error de conexión");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={openUploadImageDialog}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>Imagenes</DialogTitle>
            <DialogContent>
                {loading ? (
                    <Box display="flex" justifyContent="center" mt={4}>
                        <CircularProgress />
                    </Box>
                ) : (<DeliveryImages images={preview} title="Vista previa de imagenes" />)
                }

            </DialogContent>
            <DialogActions>
                <Button onClick={saveImages} color="secondary" variant="outlined">
                    Guardar
                </Button>
                <Button onClick={onClose} color="primary" variant="outlined">
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UploadImageDialog;
